import { takeEvery } from 'redux-saga/effects';
import { ACCEPT_TOS_PRIVACY } from './actions';
import { SET_CUSTOMER } from '../customer/actions';
import { onAcceptTOS, onSetCustomer } from './effects';

export function* setTOSSaga() {
  yield takeEvery(ACCEPT_TOS_PRIVACY, onAcceptTOS);
}

export function* setCustomerShowTermsSaga() {
  yield takeEvery(SET_CUSTOMER, onSetCustomer);
}
